<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :newEntry="newEntry"
    :createButtonDisabled="!($can('create','Person') || $can('create','PersonAlta'))"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      formErrors: [],
      entry: null,
      extraData: null,
    };
  },
  props: {
    newEntry: {
      type: Object,
      default: null,
    },
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    isCustomer: {
      type: Boolean,
      default: false
    },
    isCollaborator: {
      type: Boolean,
      default: false
    },
    isSupplier: {
      type: Boolean,
      default: false
    },
    isCarrier: {
      type: Boolean,
      default: false
    },
    isEmployee: {
      type: Boolean,
      default: false
    },
    sellerId: null,
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_PERSON_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          console.log("newEntry", this.newEntry);
          if(this.newEntry){
            console.log("newEntry", this.newEntry);
            this.entry = this.newEntry
          }else{
            this.entry = response.data.accountContext.person;
          }
          if (this.isCustomer) {
            this.entry.isCustomer = true;
          } 
          if (this.isCollaborator) {
            this.entry.isCollaborator = true;
          }
          if (this.isSupplier) {
            this.entry.isSupplier = true;
          }
          if (this.isCarrier) {
            this.entry.isCarrier = true;
          }
          if (this.isEmployee) {
            this.entry.isEmployee = true;
          }
          if(this.sellerId){
            this.entry.sellerId = this.sellerId;
          }
          // console.log(this.entry);
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(person) {
      // console.log("PERSON", person, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(person, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_PERSON_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(person, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createPerson.errors
          
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createPerson.person);
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
      } 
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_PERSON_QUERY = gql `
  {
    accountContext {
      person {
        id
        code
        kind
        leadingCompanyId
        sellerId
        regionId
        labelId
        birthDate
        tablePriceId
        cpf
        cnpj
        isCollaborator
        isCustomer
        isSupplier
        isCarrier
        isEmployee
        isDriver
        rg
        role
        hourlyPrice
        contractType {
          id
          name
        }
        contractTypeId
        name
        tradingName
        email
        phone
        cellPhone
        isFinalConsumer
        recipientStateInscription
        addressesAttributes {
          id
          cityId
          postalCode
          street
          neighborhood
          number
          complement
        }
        patrimoniesAttributes {
          id
        }
        taxPayersAttributes {
          id
        }
        customerCulturesAttributes {
          id
          harvestId
          harvest{
            id
            name
          }
          cultureId
          culture{
            id
            name
          }
          plantedArea
          globalArea
          irrigatedArea
          produced
          rentedQuantity
          isRented
        }
        routes{
          id
          name
        }
        routeIdsAttribute
        salePackagingsAttributes{
          packagingId
          packaging{
            id
            name
          }
          itemId
          item{
            id
            name
          }
        }
        recipientStateInscriptionIndicatorId
        recipientStateInscription
        taxRegimeId
        taxReceiptEmail
        validations
      }
      allTablePrices{
        id 
        name
      }
      allClients{
        id
        name
      }
      allMyCustomers{
        id
        name
      }
      allMyEmployees{
        id
        name
      }
      allRegions{
        id
        description
      }
      allPeopleLabels {
        id
        description
        colorHexaCode
        labelType
      }
    }
    globalContext {
      allPersonKinds {
        value
        text
      }
      allRecipientStateInscriptionIndicators {
        id
        code
        description
      }
      allTaxRegimes {
        id
        code
        description
      }
      allContractTypes {
        id
        name
      }
    }
  }
`;

const CREATE_PERSON_MUTATION = gql `
  mutation($input: PersonCreateInputObject!) {
    createPerson(input: $input) {
      person {
        id
        name
        isCollaborator
        isCustomer
        isSupplier
        isCarrier
        isEmployee
        isDriver
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
